export const DelishBowlEmailAddress = 'mydelishbowl.letterbox@gmail.com';
export const CucumberWebsiteAddress = 'https://mdb-cucumber-prod.netlify.app';
export const AmazonShopAddress = 'https://www.amazon.in/shop/mydelishbowl';

export const FirebaseProductsCollection = 'products';
export const FirebaseBrandsCollection = 'brands';
export const FirebaseCategoriesCollection = 'categories';
